var map = {
	"./AcademicOfficesModule.vue": [
		"e980",
		"chunk-33af5ac7"
	],
	"./AdminOfficesModule.vue": [
		"17bf",
		"chunk-61dce623"
	],
	"./AuditoriumModule.vue": [
		"2c2a",
		"chunk-3b5146b6"
	],
	"./BuildingOverviewModule.vue": [
		"cd1a",
		"chunk-cf20c95e"
	],
	"./CanteenModule.vue": [
		"5eda",
		"chunk-770e2ac5"
	],
	"./CarParkingModule.vue": [
		"5a92",
		"chunk-3109f295"
	],
	"./ClassroomsModule.vue": [
		"c4ac",
		"chunk-019c693c"
	],
	"./ClinicModule.vue": [
		"741e",
		"chunk-e07eeda0"
	],
	"./FacilityAreasModule.vue": [
		"8fad",
		"chunk-851e39f4"
	],
	"./GatesModule.vue": [
		"b9ca",
		"chunk-10d2a318"
	],
	"./LabsModule.vue": [
		"249f",
		"chunk-f7457528"
	],
	"./MeetingRoomsModule.vue": [
		"9cfa",
		"chunk-c539abce"
	],
	"./PalmAndTreesModule.vue": [
		"3cbe",
		"chunk-2f568efa"
	],
	"./PantriesKitchenModule.vue": [
		"42e1",
		"chunk-68a960a8"
	],
	"./PrayerRoomModule.vue": [
		"1d3b",
		"chunk-4da45ce4"
	],
	"./SecurityCamModule.vue": [
		"d416",
		"chunk-3cc52ab2"
	],
	"./ServiceRoomsModule.vue": [
		"b8f2",
		"chunk-962c82ac"
	],
	"./SportFacilitiesModule.vue": [
		"4007",
		"chunk-20b49a0a"
	],
	"./StoresModule.vue": [
		"43bb",
		"chunk-630aa054"
	],
	"./ToiletsModule.vue": [
		"3743",
		"chunk-26a5cf8d"
	],
	"./VendingMachinesModule.vue": [
		"159a",
		"chunk-5d31e444"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "92d0";
module.exports = webpackAsyncContext;